/**
 * @ The external dependecies
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormRemoveSelected from "components/form/FormRemoveSelected";

/**
 * @class      ModalRemoveSelected (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalRemoveSelected = (props) => {
  return (
    <ModalFrame>
      <FormRemoveSelected />
    </ModalFrame>
  );
};

export default ModalRemoveSelected;
